import React from 'react';
import {AutocompleteRenderInputParams, TextField} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { IAccount } from '../Interfaces/IAccount';
import {checkPermission} from "../utils/permission";

interface AccountsFieldProps {
    allAccounts: IAccount[];
    selectedAccounts: IAccount[];
    onChange: (newSelected: IAccount[]) => void;
    label: String;
    readOnly?: boolean;
}

const AccountsField: React.FC<AccountsFieldProps> = ({ allAccounts, selectedAccounts, onChange, label, readOnly }) => {

    const effectiveReadOnly = readOnly !== undefined ? readOnly : !checkPermission(1, 2);

    return (
        <Autocomplete
            multiple
            fullWidth
            options={allAccounts}
            getOptionLabel={(option: IAccount) => {
                const name = `${option.first_name || ''} ${option.last_name || ''}`.trim();
                return name || option.username;
            }}
            value={selectedAccounts}
            onChange={(_, newValue) => {
                onChange(newValue as IAccount[]);
            }}
            readOnly={effectiveReadOnly}
            renderInput={(params: AutocompleteRenderInputParams) =>
                React.createElement(TextField, {
                    ...params as any,
                    label: label,
                    placeholder: "Wähle Bundesbrüder aus",
                    variant: "outlined",
                    size: "small",
                })
            }
        />
    );
};

export default AccountsField;
